import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  ViewChild,
  Output,
  ElementRef,
} from '@angular/core';
import {
  AlertController,
  IonContent,
  IonList,
  ModalController,
  PopoverController,
  NavController
} from '@ionic/angular';


import { DataService } from '../../services/data.service';
import { Storage } from '@ionic/storage-angular';
// import { Storage } from '@ionic/storage';
import {
  ActivatedRoute,
  Router,
} from '@angular/router';
import { NavigationExtras } from '@angular/router';
@Component({
  selector: 'app-discount-list',
  templateUrl: './discount-list.component.html',
  styleUrls: ['./discount-list.component.scss'],
})
export class DiscountListComponent implements OnInit {

  @Input() loadMoreData;
  @Input() discount_list: any = [];
  check_box:any;
  constructor(public storage: Storage,public db:DataService,private router:Router,private activatedRoute:ActivatedRoute,private navCtrl:NavController) { }

  ngOnInit() {}

  onScroll(event){

  }

  order_list(item){

  }

  edit_discount(d ,index){
    let params:NavigationExtras={
      queryParams:{'id':d.name}
    }
    this.navCtrl.navigateForward(['add-discount'], params);
  }

}
